import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelSelect as _vModelSelect, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, normalizeClass as _normalizeClass, withCtx as _withCtx } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = {
  key: 0,
  class: "d-flex align-items-center mb-3"
}
const _hoisted_3 = { class: "d-flex" }
const _hoisted_4 = { class: "form-group" }
const _hoisted_5 = { value: null }
const _hoisted_6 = ["value"]
const _hoisted_7 = { class: "ml-2 d-flex flex-column" }
const _hoisted_8 = ["onDrop"]
const _hoisted_9 = { class: "trelloTitle" }
const _hoisted_10 = { class: "float-right fs-14 text-success" }
const _hoisted_11 = { key: 0 }
const _hoisted_12 = { key: 1 }
const _hoisted_13 = { key: 2 }
const _hoisted_14 = { key: 3 }
const _hoisted_15 = { key: 4 }
const _hoisted_16 = { key: 5 }
const _hoisted_17 = { key: 6 }
const _hoisted_18 = { key: 7 }
const _hoisted_19 = { key: 8 }
const _hoisted_20 = { key: 9 }
const _hoisted_21 = { key: 10 }
const _hoisted_22 = { class: "trelloTaskContainer" }
const _hoisted_23 = { class: "trelloTaskPlaceholder" }
const _hoisted_24 = { key: 0 }
const _hoisted_25 = { key: 1 }
const _hoisted_26 = { key: 2 }
const _hoisted_27 = { key: 3 }
const _hoisted_28 = { key: 4 }
const _hoisted_29 = { key: 5 }
const _hoisted_30 = { key: 6 }
const _hoisted_31 = { key: 7 }
const _hoisted_32 = ["onDragstart"]
const _hoisted_33 = { class: "mb-1 d-flex justify-content-between flex-row-reverse align-items-center" }
const _hoisted_34 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_35 = {
  key: 0,
  class: "text-center"
}
const _hoisted_36 = {
  key: 1,
  class: "text-center"
}
const _hoisted_37 = { key: 2 }
const _hoisted_38 = { class: "text-right" }
const _hoisted_39 = { class: "label" }
const _hoisted_40 = ["onClick"]
const _hoisted_41 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-edit" }, null, -1)
const _hoisted_42 = /*#__PURE__*/_createTextVNode()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_localized_text = _resolveComponent("localized-text")!
  const _component_toggler = _resolveComponent("toggler")!
  const _component_trello_container = _resolveComponent("trello-container")!
  const _directive_leadstatus = _resolveDirective("leadstatus")!

  return (_ctx.colonne)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (_ctx.$store.state.isAdmin() || _ctx.$store.state.isManager())
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                  _createElementVNode("label", null, [
                    _createVNode(_component_localized_text, {
                      localizedKey: "Filtra per nodo della rete",
                      text: "Filtra per nodo della rete"
                    })
                  ]),
                  _withDirectives(_createElementVNode("select", {
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.userFilter) = $event)),
                    class: "form-control"
                  }, [
                    _createElementVNode("option", _hoisted_5, _toDisplayString(_ctx.$localizationService.GetLocalizedValue("Mostra tutti", "Mostra tutti")), 1),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.usersForDropdownReferrer, (user) => {
                      return (_openBlock(), _createElementBlock("option", {
                        value: user.identifier,
                        key: user.identifier
                      }, _toDisplayString(user.name), 9, _hoisted_6))
                    }), 128))
                  ], 512), [
                    [_vModelSelect, _ctx.userFilter]
                  ])
                ]),
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("span", null, [
                    _createVNode(_component_localized_text, {
                      localizedKey: "Vedi sottonodi",
                      text: "Vedi sottonodi"
                    })
                  ]),
                  _createVNode(_component_toggler, {
                    class: "mt-2",
                    modelValue: _ctx.descendants,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.descendants) = $event))
                  }, null, 8, ["modelValue"])
                ])
              ])
            ]))
          : _createCommentVNode("", true),
        _createVNode(_component_trello_container, { ref: "trello" }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.colonne, (value, key, i) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "trelloGroup",
                key: i,
                onDrop: ($event: any) => (_ctx.onDrop($event, key)),
                onDragover: _cache[2] || (_cache[2] = ($event: any) => (_ctx.onDragOver($event)))
              }, [
                _createElementVNode("div", _hoisted_9, [
                  _createElementVNode("b", _hoisted_10, _toDisplayString(value.length), 1),
                  (key == 'inArrivo')
                    ? (_openBlock(), _createElementBlock("span", _hoisted_11, [
                        _createVNode(_component_localized_text, {
                          localizedKey: "In arrivo",
                          text: "In arrivo"
                        })
                      ]))
                    : (key == 'appuntamento')
                      ? (_openBlock(), _createElementBlock("span", _hoisted_12, [
                          _createVNode(_component_localized_text, {
                            localizedKey: "Appuntamento",
                            text: "Appuntamento"
                          })
                        ]))
                      : (key == 'trattamento')
                        ? (_openBlock(), _createElementBlock("span", _hoisted_13, [
                            _createVNode(_component_localized_text, {
                              localizedKey: "Trattamento",
                              text: "Trattamento"
                            })
                          ]))
                        : (key == 'mese1')
                          ? (_openBlock(), _createElementBlock("span", _hoisted_14, [
                              _createVNode(_component_localized_text, {
                                localizedKey: "Mese1",
                                text: "Mese1"
                              })
                            ]))
                          : (key == 'mese2')
                            ? (_openBlock(), _createElementBlock("span", _hoisted_15, [
                                _createVNode(_component_localized_text, {
                                  localizedKey: "Mese2",
                                  text: "Mese2"
                                })
                              ]))
                            : (key == 'mese3')
                              ? (_openBlock(), _createElementBlock("span", _hoisted_16, [
                                  _createVNode(_component_localized_text, {
                                    localizedKey: "Mese3",
                                    text: "Mese3"
                                  })
                                ]))
                              : (key == 'mese4')
                                ? (_openBlock(), _createElementBlock("span", _hoisted_17, [
                                    _createVNode(_component_localized_text, {
                                      localizedKey: "Mese4",
                                      text: "Mese4"
                                    })
                                  ]))
                                : (key == 'mese5')
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_18, [
                                      _createVNode(_component_localized_text, {
                                        localizedKey: "Mese5",
                                        text: "Mese5"
                                      })
                                    ]))
                                  : (key == 'mese6')
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_19, [
                                        _createVNode(_component_localized_text, {
                                          localizedKey: "Mese6",
                                          text: "Mese6"
                                        })
                                      ]))
                                    : (key == 'ricaduto')
                                      ? (_openBlock(), _createElementBlock("span", _hoisted_20, [
                                          _createVNode(_component_localized_text, {
                                            localizedKey: "Ricaduto",
                                            text: "Ricaduto"
                                          })
                                        ]))
                                      : (key == 'conclusionePositiva')
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_21, [
                                            _createVNode(_component_localized_text, {
                                              localizedKey: "Conclusione Positiva",
                                              text: "Conclusione Positiva"
                                            })
                                          ]))
                                        : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_22, [
                  _createElementVNode("div", _hoisted_23, [
                    (key == 'inArrivo')
                      ? (_openBlock(), _createElementBlock("span", _hoisted_24, [
                          _createVNode(_component_localized_text, {
                            localizedKey: "In arrivo",
                            text: "In arrivo"
                          })
                        ]))
                      : (key == 'appuntamento')
                        ? (_openBlock(), _createElementBlock("span", _hoisted_25, [
                            _createVNode(_component_localized_text, {
                              localizedKey: "Appuntamento",
                              text: "Appuntamento"
                            })
                          ]))
                        : (key == 'trattamento')
                          ? (_openBlock(), _createElementBlock("span", _hoisted_26, [
                              _createVNode(_component_localized_text, {
                                localizedKey: "Trattamento",
                                text: "Trattamento"
                              })
                            ]))
                          : (key == 'mese1')
                            ? (_openBlock(), _createElementBlock("span", _hoisted_27, [
                                _createVNode(_component_localized_text, {
                                  localizedKey: "Mese1",
                                  text: "Mese1"
                                })
                              ]))
                            : (key == 'mese2')
                              ? (_openBlock(), _createElementBlock("span", _hoisted_28, [
                                  _createVNode(_component_localized_text, {
                                    localizedKey: "Mese2",
                                    text: "Mese2"
                                  })
                                ]))
                              : (key == 'mese3')
                                ? (_openBlock(), _createElementBlock("span", _hoisted_29, [
                                    _createVNode(_component_localized_text, {
                                      localizedKey: "Mese3",
                                      text: "Mese3"
                                    })
                                  ]))
                                : (key == 'ricaduto')
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_30, [
                                      _createVNode(_component_localized_text, {
                                        localizedKey: "Ricaduto",
                                        text: "Ricaduto"
                                      })
                                    ]))
                                  : (key == 'conclusionePositiva')
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_31, [
                                        _createVNode(_component_localized_text, {
                                          localizedKey: "Conclusione Positiva",
                                          text: "Conclusione Positiva"
                                        })
                                      ]))
                                    : _createCommentVNode("", true)
                  ]),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(value, (item, ii) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: "trelloTask",
                      key: ii,
                      draggable: "true",
                      onDragstart: ($event: any) => (_ctx.onDragStart($event, item, key))
                    }, [
                      _withDirectives((_openBlock(), _createElementBlock("div", {
                        class: _normalizeClass(["borderedLabel", { 'border-orange': _ctx.isOfToday(item) }])
                      }, [
                        _createElementVNode("p", _hoisted_33, [
                          _createElementVNode("span", null, _toDisplayString(item.scadenze[0] && _ctx.$filters.date(item.scadenze[0].startDate)), 1),
                          (_ctx.getRitardo(item))
                            ? (_openBlock(), _createElementBlock("b", _hoisted_34, [
                                _createTextVNode(_toDisplayString(_ctx.getRitardo(item)) + " ", 1),
                                _createVNode(_component_localized_text, {
                                  localizedKey: "GG RITARDO!",
                                  text: "GG RITARDO!"
                                })
                              ]))
                            : _createCommentVNode("", true)
                        ]),
                        (item.name || item.surname)
                          ? (_openBlock(), _createElementBlock("p", _hoisted_35, [
                              _createElementVNode("b", null, _toDisplayString(item.name) + " " + _toDisplayString(item.surname), 1)
                            ]))
                          : (_openBlock(), _createElementBlock("p", _hoisted_36, [
                              _createElementVNode("b", null, _toDisplayString(item.contactName), 1)
                            ])),
                        (item.scadenze && item.scadenze[0] && key as any != 'conclusioneNegativa' && key != 'conclusionePositiva')
                          ? (_openBlock(), _createElementBlock("p", _hoisted_37, _toDisplayString(item.scadenze[0].text), 1))
                          : _createCommentVNode("", true),
                        _createElementVNode("div", _hoisted_38, [
                          _withDirectives((_openBlock(), _createElementBlock("span", _hoisted_39, [
                            _createTextVNode(_toDisplayString(_ctx.getLeadStatus(item)), 1)
                          ])), [
                            [_directive_leadstatus, item]
                          ])
                        ])
                      ], 2)), [
                        [_directive_leadstatus, item]
                      ]),
                      _createElementVNode("button", {
                        type: "button",
                        class: "detailButton",
                        onClick: ($event: any) => (_ctx.openLeadModal(item, value))
                      }, [
                        _hoisted_41,
                        _hoisted_42,
                        _createVNode(_component_localized_text, {
                          localizedKey: "Apri",
                          text: "Apri"
                        })
                      ], 8, _hoisted_40)
                    ], 40, _hoisted_32))
                  }), 128))
                ])
              ], 40, _hoisted_8))
            }), 128))
          ]),
          _: 1
        }, 512)
      ]))
    : _createCommentVNode("", true)
}